import React from 'react';

import Card from "@mui/joy/Card";
import Chip from "@mui/joy/Chip";
import CardContent from "@mui/joy/CardContent";
import {Stack} from "@mui/joy";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import ProfileHorizontalByProps from "../Profile/ProfileHorizontalByProps";
import SliceDetailModal from "./SliceDetailModal";
import OpportunityCard from "../Cards/OpportunityCard";
import dayjs from "dayjs";
import {getWeekRange} from "../../utils/misc";


class SliceCard extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            slice: this.props.slice,
        };
    }

    setSlice(slice){
        this.setState({
            slice: slice,
        })
    }

    render() {
        const { start, end } = getWeekRange(this.state.slice.week, (new Date()).getFullYear());
        return (
            <Card
                size={'sm'}
                variant={this.props.variant?this.props.variant:'plain'}
            >
                <CardContent>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack
                            direction={'row'}
                            alignItems="center"
                            spacing={1}
                            flexWrap={'nowrap'}
                        >
                            <SliceDetailModal
                                overlay={true}
                                slice={this.state.slice}
                                showOpportunity={this.props.showOpportunity}
                                callBack={this.setSlice.bind(this)}
                            />
                            {
                                this.props.showOpportunity?
                                    <OpportunityCard
                                        opportunity={this.state.slice.opportunity}
                                        nano={true}
                                    />:
                                    null
                            }
                            <Chip
                                color={'neutral'}
                                size={'sm'}
                            >
                                Год: {this.state.slice.year}
                            </Chip>
                            <Chip
                                color={'neutral'}
                                size={'sm'}

                            >
                                Неделя: {this.state.slice.week}
                            </Chip>
                            <Chip>
                                {dayjs(start).format('DD.MM.YYYY')} - {dayjs(end).format('DD.MM.YYYY')}
                            </Chip>
                            <Chip
                                color={this.state.slice.color}
                                variant={'plain'}
                                size={'sm'}
                            >
                                {this.state.slice.role_human}
                            </Chip>
                            {
                                this.state.slice.pre_week_completed?
                                    <Chip
                                        color={'success'}
                                        size={'sm'}
                                    >
                                        Планирование завершено
                                    </Chip>:
                                    <Chip
                                        color={'danger'}
                                        size={'sm'}
                                    >
                                        Планирование не завершено
                                    </Chip>
                            }
                            {
                                this.state.slice.post_week_completed?
                                    <Chip
                                        color={'success'}
                                        size={'sm'}
                                    >
                                        Оценка завершена
                                    </Chip>:
                                    <Chip
                                        color={'danger'}
                                        size={'sm'}
                                    >
                                        Оценка не проведена
                                    </Chip>
                            }
                            {
                                this.props.showOperator?
                                    <ProfileHorizontalByProps
                                        user={this.state.slice.operator.user}
                                    />:
                                    null
                            }
                            <Chip
                                variant={'plain'}
                                size={'sm'}
                            >
                                {this.state.slice.duration_plan}
                            </Chip>
                            <Chip
                                variant={'plain'}
                                size={'sm'}
                            >
                                {this.state.slice.duration_fact}
                            </Chip>
                        </Stack>
                        <Stack
                            direction={'row'}
                        >

                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
        )
    }
}

export default SliceCard